import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const useEditUserValidationSchema = () => {
	const { t } = useTranslation()

	const editUserValidationSchema = yup.object({
		email: yup.string().required(t('Email is required')),
		address: yup.object({
			address: yup.string().required(t('Address is required')),
			postal_code: yup.string().required(t('Postal code is required')),
			city: yup.string().required(t('City is required'))
		}),
		country: yup.object({
			value: yup.string().required(t('Country is required'))
		})
	})

	return yupResolver(editUserValidationSchema)
}
